import { FilterGroupEnum, } from '@honeycomb/data';
import { initDataLayer, isBrowser, persistTrackingData } from '../util';
function isFilterSelected(filterGroup) {
    if (filterGroup.type === FilterGroupEnum.Checkbox) {
        return filterGroup.items.some((item) => item.selected);
    }
    if (filterGroup.type === FilterGroupEnum.Range || filterGroup.type === FilterGroupEnum.Pricerange) {
        const { min, max, lower, upper } = filterGroup;
        return lower > min || upper < max;
    }
    if (filterGroup.type === FilterGroupEnum.Text) {
        const { value } = filterGroup;
        return value !== '';
    }
    return false;
}
export function pushFilters({ filterGroups: data }) {
    initDataLayer();
    if (!isBrowser)
        return;
    const appliedFilters = [];
    const activeFilterGroups = data.filter(isFilterSelected);
    if (activeFilterGroups.length === 0) {
        // filters reset, clear from dataLayer
        window.dataLayer.push({ appliedFilters: undefined });
        return;
    }
    activeFilterGroups.forEach((filterGroup) => {
        if (filterGroup.type === FilterGroupEnum.Checkbox) {
            filterGroup.items.forEach((item) => {
                if (item.selected) {
                    appliedFilters.push({
                        filterName: filterGroup.name,
                        filterValue: item.label,
                    });
                }
            });
        }
        if (filterGroup.type === FilterGroupEnum.Range || filterGroup.type === FilterGroupEnum.Pricerange) {
            const { name, lower, upper } = filterGroup;
            appliedFilters.push({
                filterName: `${name}`,
                filterValue: `${lower}-${upper}`,
            });
        }
        if (filterGroup.type === FilterGroupEnum.Text) {
            const { id, value } = filterGroup;
            if (value) {
                appliedFilters.push({
                    filterName: id,
                    filterValue: value,
                });
            }
        }
    });
    window.dataLayer.push({ event: 'filtersApplied', appliedFilters });
    persistTrackingData({ appliedFilters });
}
